import { render, staticRenderFns } from "./EmployeeCard.vue?vue&type=template&id=4c1ce59e&"
import script from "./EmployeeCard.vue?vue&type=script&lang=ts&"
export * from "./EmployeeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports